import axios from 'axios'
import {UserModel, LoginResponseModel} from './_models'
import {API_CONFIG, buildRequestBody, handleApiError} from './_config'
import {setTokenInStorage} from './AuthHelpers'

const API_URL = API_CONFIG.BASE_URL

// Interceptor de axios para leer el token del header
axios.interceptors.response.use(
  (response) => {
    // Intentar extraer el token del header
    const newToken = response.headers['x-token'] || response.headers['X-TOKEN']
    if (newToken && typeof newToken === 'string') {
      setTokenInStorage(newToken)
      
      // También actualizar el token en la respuesta para compatibilidad
      if (response.data && typeof response.data === 'object') {
        response.data.api_token = newToken
      }
    }
    return response
  },
  (error) => {
    return Promise.reject(error)
  }
)

export const GET_USER_BY_ACCESSTOKEN_URL = `${API_URL}`
export const LOGIN_URL = `${API_URL}` // Momentaneamente solo hay login de socios
export const REGISTER_URL = `${API_URL}` // No hay registro de socios
export const REQUEST_PASSWORD_URL = `${API_URL}` // No hay recuperación de contraseña

// Server should return LoginResponseModel with complete user data
export function login(email: string, password: string) {
  return axios.post<LoginResponseModel>(LOGIN_URL, 
    buildRequestBody(API_CONFIG.SERVICES.LOGIN, { email, password })
  ).catch(error => {
    throw new Error(handleApiError(error))
  })
}

// Server should return AuthModel  
export function register(
  email: string,
  firstname: string,
  lastname: string,
  password: string,
  password_confirmation: string
) {
  return axios.post(REGISTER_URL, 
    buildRequestBody(API_CONFIG.SERVICES.REGISTER, {
      email,
      first_name: firstname,
      last_name: lastname,
      password,
      password_confirmation,
    })
  ).catch(error => {
    throw new Error(handleApiError(error))
  })
}

// Server should return object => { result: boolean } (Is Email in DB)
export function requestPassword(email: string) {
  return axios.post<{result: boolean}>(REQUEST_PASSWORD_URL, 
    buildRequestBody(API_CONFIG.SERVICES.FORGOT_PASSWORD, { email })
  ).catch(error => {
    throw new Error(handleApiError(error))
  })
}

export function getUserByToken(token: string) {
  return axios.post<UserModel>(GET_USER_BY_ACCESSTOKEN_URL, 
    buildRequestBody(API_CONFIG.SERVICES.VERIFY_TOKEN, { api_token: token })
  ).catch(error => {
    throw new Error(handleApiError(error))
  })
}
